export class SupplierFunctionWrapper {
  public getValue: () => any = () => null;
}
